exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-box {\n  border: 1px solid #ccc;\n  margin-top: 0px;\n  background-color: #fff;\n  text-align: center;\n  font-size: 0.98rem;\n  border-top: 0px;\n  padding-top: 8px;\n  padding-bottom: 8px; }\n\n.list-box-header {\n  border: 1px solid #ccc;\n  margin-top: 20px;\n  height: 50px;\n  padding-top: 12px;\n  background: #e4f1fc;\n  box-shadow: 0px -1px 5px 0px #ccc;\n  font-size: 0.98rem;\n  text-align: center;\n  border-bottom: 0px; }\n\n.bdb {\n  border-bottom: 1px dashed #ccc;\n  padding-top: 4px;\n  padding-bottom: 4px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/trade-back/trade-delivery.scss
// module id = ../../../../../src/app/pages/trade-back/trade-delivery.scss
// module chunks = 39